var map = {
	".": 72812,
	"./": 72812,
	"./AboutUs": 72495,
	"./AboutUs.js": 72495,
	"./App": 48547,
	"./App.css": 44050,
	"./App.js": 48547,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./BasePage": 49352,
	"./BasePage.js": 49352,
	"./ContactUs": 57187,
	"./ContactUs.js": 57187,
	"./FaqsPage": 10503,
	"./FaqsPage.js": 10503,
	"./Footer": 79977,
	"./Footer.js": 79977,
	"./HomePage": 83650,
	"./HomePage.js": 83650,
	"./ImageVideoCoursel": 39675,
	"./ImageVideoCoursel.js": 39675,
	"./ProductCard": 2737,
	"./ProductCard.js": 2737,
	"./ProductDetails": 85369,
	"./ProductDetails.js": 85369,
	"./ReviewSection": 89656,
	"./ReviewSection.js": 89656,
	"./abd.txt": 72457,
	"./header": 10871,
	"./header.js": 10871,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 82260,
	"./setupTests.js": 82260,
	"./temp": 91056,
	"./temp.js": 91056,
	"./temp2": 64606,
	"./temp2.js": 64606,
	"./utils/FAQsData": 64662,
	"./utils/FAQsData.json": 64662,
	"./utils/MainImagesMockData": 26002,
	"./utils/MainImagesMockData.json": 26002,
	"./utils/ProductsMockData": 2693,
	"./utils/ProductsMockData.json": 2693,
	"./utils/ReviewsMockData": 65974,
	"./utils/ReviewsMockData.json": 65974,
	"./utils/Screenshot 2025-08-24 at 9.15.32 PM.png": 78970,
	"./utils/constants": 56543,
	"./utils/constants.js": 56543,
	"./utils/images/All_flour_Mills.mp4": 18018,
	"./utils/images/Manufacturing1.png": 25438,
	"./utils/images/Manufacturing2.png": 27541,
	"./utils/images/Manufacturing3.png": 44652,
	"./utils/images/Manufacturing4.png": 74819,
	"./utils/images/PREMIUM(1).mp4": 6515,
	"./utils/images/PREMIUM(2).mp4": 97894,
	"./utils/images/PREMIUM.mp4": 65961,
	"./utils/images/Plug_It.png": 96025,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS.png": 63980,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_1.png": 28444,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_2.png": 12727,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_3.png": 69710,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_4.png": 22177,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_5.png": 37560,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_6.png": 12051,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_7.png": 73194,
	"./utils/images/RIDHI_SIDHI_FLOUR_MILLS_8.png": 7261,
	"./utils/images/door-manufacturers1-door-manufacturers-1-dgovo.avif": 29479,
	"./utils/images/img1.jpg": 96047,
	"./utils/images/img2.png": 83236,
	"./utils/images/img3.png": 9389,
	"./utils/images/img4.png": 27826,
	"./utils/images/img5.jpg": 48915,
	"./utils/images/img5.png": 76827,
	"./utils/images/img6.png": 38144,
	"./utils/section": 64253,
	"./utils/section.js": 64253,
	"./utils/theme": 62495,
	"./utils/theme.js": 62495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81407;